///all in one
import axios from "@/axios";
export const countryCodeStates = [];

export const countryCodeGetters = {
  getCountryCode: state => {
    return state.countryCode;
  }
};

export const countryCodeMutations = {
  changeCountryCode(state, value) {
    state.countryCode = value;
  }
};

export const countryCodeActions = {
  act_loadCountryCode: async ({ commit }) => {
    let respone = await axios.get("countrycode");
    commit("changeCountryCode", respone.data.data);
  }
};
